<template>
  <div id="top">
    <ContentHeader class="content" />
    <div v-if="this.$vuetify.breakpoint.lgAndUp">
      <div class="text">
        <h2>Portfolio</h2>
      </div>
      <div class="photos_viewphotos_div">
        <v-layout>
          <v-col class="columns mt-5 view_photo" cols="4">
            <div v-for="(item) in selectedSpecies[0]" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {species: 'portfolio', id: item[1]}}">
                <v-img contain class="photo" :src="item[0]"><p class="link">{{item[0]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
          <v-col class="columns mt-5 view_photo" cols="4">
            <div v-for="(item) in selectedSpecies[1]" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {species: 'portfolio', id: item[1]}}">
                <v-img contain class="photo" :src="item[0]"><p class="link">{{item[1]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
          <v-col class="columns mt-5 view_photo" cols="4">
            <div v-for="(item) in selectedSpecies[2]" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {species: 'portfolio', id: item[1]}}">
                <v-img contain class="photo" :src="item[0]"><p class="link">{{item[2]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
        </v-layout>
        <v-layout>
          <Footer class="footer mt-5" />
        </v-layout>
      </div>
    </div>
    <div v-else>
      <div class="text-phone">
        <h2>Portfolio</h2>
      </div>
      <div class="photos_viewphotos_div">
        <v-layout>
          <v-col cols="1"></v-col>
          <v-col class="columns mt-5 view_photo" cols="10">
            <div v-for="(item) in selectedSpeciesPhone" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {species: 'portfolio', id: item[1]}}">
                <v-img contain class="photo" :src="item[0]"><p class="link">{{item[0]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
        </v-layout>
        <v-layout>
          <Footer class="footer mt-5" />
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "GalleryPortfolio",
  data() {
    return {
      photos: []
    };
  },
  methods: {
    ...mapMutations(["SET_CAROUSELPORT"])
  },
  components: {
    ContentHeader,
    Footer
  },
  computed: {
    selectedSpeciesPhone() {
      var e = [];
      for (var i = 0; i < this.photos.length; i++) {
        if (this.photos[i]["portfolio"] && e.length <= 150) {
          e.push([
            String("https://pascaldemunckbackend.com" + this.photos[i]["image"]),
            this.photos[i]["id"]
          ]);
        }
      }
      this.SET_CAROUSELPORT(e);
      return e;
    },
    selectedSpecies() {
      var e1 = [];
      var e2 = [];
      var e3 = [];
      var e = this.selectedSpeciesPhone;
      var index = 1;
      for (var i = 0; i < e.length; i++) {
        if (index == 3) {
          e3.push(e[i]);
          index = 1;
        } else if (index == 2) {
          e2.push(e[i]);
          index++;
        } else if (index == 1) {
          e1.push(e[i]);
          index++;
        }
      }
      return [e1, e2, e3];
    }
  },
  mounted() {
    axios.get("https://pascaldemunckbackend.com/api/photos/1/getTravelPhotos/").then(res => {
      this.photos = res.data;
    });
  }
};
</script>

<style scoped>
.footer{
  width: 100%
}
.test {
  position: absolute;
  left: 25%;
  top: 11%;
}
.photos_viewphotos {
  position: absolute;
  width: 100%;
  top: 8%;
}
.text {
  position: absolute;
  top: 13%;
  left: 42%;
}
.text-phone {
  position: absolute;
  top: 13%;
  left: 28%;
}
.photos_viewphotos_div {
  position: absolute;
  width: 100%;
  top: 21%;
}

.footer_photos {
  width: 100%;
  position: absolute;
  left: 0;
}
.columns {
  padding: 0;
  margin: 0;
}

.photo {
  transform: scale(1.05);
  transition: transform 0.5s;
}

.photo:hover {
  transform: scale(1.15);
}

.view_photo {
  overflow: hidden;
}

.content {
  background-color: black;
}
.link {
  opacity: 0;
}
</style>